export { default, Types, SUGGEST_TYPES } from './MessengerForm2';
